import React, { useState } from "react";
import "./AccordionItem.scss"; // подключим стили отдельно

const AccordionItem = ({ title, content }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`accordion-item ${isOpen ? "open" : ""}`}>
            <button
                className="accordion-item__button"
                onClick={() => setIsOpen(!isOpen)}
            >
                {title}
            </button>
            <div className={`accordion-item__content ${isOpen ? "open" : ""}`}>
                <div className="accordion-item__text">
                    {content}
                </div>
            </div>
        </div>
    );
}

export { AccordionItem };
